import { MikanSpan } from "../Mikan"
import { withPrefix } from "gatsby"
import { Card, LabelList } from "@fastly/consistently"
import FastlySlugify from "@components/fastly-slugify"

const ResourceCard = ({ content: { title, description, type, url }, labels, showTag = false }) => {
  const tags =
    showTag && type ? (
      <LabelList labels={[{ title: labels?.[`resources:${FastlySlugify(type)}`] || type, link: `?q=${type}` }]} />
    ) : null

  return (
    <Card
      link={withPrefix(url)}
      type="std"
      header={
        <h3>
          <a href={withPrefix(url)} type="application/pdf;">
            <MikanSpan>{title}</MikanSpan>
          </a>
        </h3>
      }
      summary={
        <div className="c-card__summary">
          <MikanSpan justify>{description}</MikanSpan>
        </div>
      }
      footer={tags}
    />
  )
}

export default ResourceCard
